import { createAxiosClient } from "@ntg/component-library/utilities";

export const getReleasedProductExistsD365 = async (
    itemNumber: string,
    dataAreaId: string,
): Promise<boolean> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<boolean>(
        "/ReleasedProduct/GetReleasedProductExistsD365",
        {
            keys: { itemNumber, dataAreaId, itemID: 0 },
        },
    );
    return response.data;
};
